<template>
    <div>
        <div class="flex justify-between">
            <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
        </div>
        <div class="mt-1">
            <input required v-model="fields.email" type="email" name="email" id="email"
                   class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                   :class="{'border-red-500': getError('email')}"
                   placeholder="email@google.com"/>
            <span class="text-red-500 text-xs" v-if="getError('email')">{{ getError('email') }}</span>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    props: {
        destinationId: {
            required: true
        },
        errors: {
            default: []
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        fields: {
            get() {
                return this.code.destinations[this.destinationId].data
            },
            set(val) {
                this.updateDestinationData(this.destinationId, val)
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestinationData']),
        getError(field) {
            return this.errors[field]
        }
    }
}
</script>